
const NS = 'ExpandablePanelComponent';

// requiring html templates so that hot reloading works
const template = require('./expandablePanel.component.html');

export default {
  bindings: {
    width: '<',
    right: '@',
    open: '=',
  },
  transclude: true,
  template,
  controllerAs: 'vm',
  controller
};

// just exported for unit tests
export function controller($scope, $element, $rootScope, $timeout, unregister) {
  "ngInject";

  const vm = this;
  let listeners;
  let panel;

  vm.$onInit = () => {

    panel = $element[0].querySelector(`[data-ref="root"]`);
    if (vm.right) {
      // the panel is on the right
      panel.classList.add('right');
    }

    listeners = [];
    listeners.push($scope.$watch(() => vm.width, onWidthChange));


    if (vm.open) {
      vm.openPanel();
    } else {
      vm.closePanel();
    }
  }

  vm.$onDestroy = () => {
    unregister(listeners);
  }


  vm.togglePanel = function () {
    if (vm.open) {
      vm.closePanel();
    } else {
      vm.openPanel();
    }
  };

  vm.openPanel = function () {
    vm.open = true;
    vm.state = 'open';
    panel.style.width = vm.width + 'px';
    startResize();
  };

  vm.closePanel = function () {
    vm.open = false;
    vm.state = 'closed';
    panel.style.width = '0px';
    startResize();
  };

  function startResize() {
    emitResize(1);
  }

  function emitResize(times) {
    if (times < 8) {
      $rootScope.$broadcast('rezise');
      $timeout(() => {
        times = times += 1;
        emitResize(times);
      }, 40);
    }
  }

  function onWidthChange(newVal, oldVal) {
    if (newVal !== oldVal && vm.open) {
      vm.openPanel();
    }
  }
}
